import Text from '@passkeys/ui/text';

import AnimatedGrid from './animated-grid.js';

function EmptyState() {
  return (
    <div className="flex size-full flex-col items-center justify-center pb-[104px] pt-4">
      <AnimatedGrid className="-mx-4 mb-10" />

      <div className="flex flex-col items-center justify-center px-4">
        <Text className="mb-4" size={24} dataTestId="empty-state-title">
          Nothing here yet
        </Text>
        <Text
          align="center"
          size={16}
          className="mb-8 text-balance leading-5 text-black/65 theme-dark:text-white/50"
        >
          Explore web3 and find your first collectible.
        </Text>
      </div>
    </div>
  );
}

export default EmptyState;
